import {
    useEffect, useState, useMemo, useRef, useContext,
} from 'react';
import useLayout from '../layout/useLayout';
import { LayoutContext } from '../../contexts/layout';

interface IUseModalOptions {
    onHide?: () => void;
}

export const useModal = ({ onHide }: IUseModalOptions = {}) => {
    const [visible, setVisible] = useState(false);
    const [layoutLoading, setLayoutLoading] = useState(false);
    const rowId = useRef<string|number>();
    const { layoutId } = useContext(LayoutContext);

    const { clearLayout, getLayout, layout } = useLayout(layoutId, true);

    const hide = () => {
        if (typeof onHide === 'function') {
            onHide();
        }
        setVisible(false);
    };

    const show = async (layoutLink: string, rowIdParam?: string | number | null, idOwner?: string | number | null) => {
        const urlSearchParams = new URLSearchParams();

        if (typeof rowIdParam === 'string' || typeof rowIdParam === 'number') {
            urlSearchParams.append('id', rowIdParam.toString());
            rowId.current = rowIdParam;
        }

        if (typeof idOwner === 'string' || typeof idOwner === 'number') {
            urlSearchParams.append('idOwner', idOwner.toString());
        }

        if (Array.from(urlSearchParams).length > 0) {
            layoutLink += `?${urlSearchParams.toString()}`;
        }

        setVisible(true);
        setLayoutLoading(true);
        await getLayout(layoutLink);
        setLayoutLoading(false);
    };

    const modalContextValue = useMemo(() => ({ visible, setVisible, hide }), [visible]);

    useEffect(() => {
        if (!visible) {
            clearLayout();
            rowId.current = undefined;
        }
    }, [visible]);

    return {
        hide,
        show,
        visible,
        layout,
        layoutLoading,
        modalContextValue,
        rowId: rowId.current,
    };
};
